import React, { useState } from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FEEDBACK_URL = 'https://tamu.qualtrics.com/jfe/form/SV_4SYrwoWPQh7TZz0';

const FeedbackBanner = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#fdf2cf',
        color: '#4a1711',
        borderBottom: '1px solid #e5d9a6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4 },
        py: 1.5,
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
      }}
      role="status"
      aria-live="polite"
    >
      <Typography
        variant="body2"
        sx={{
          textAlign: 'center',
          fontWeight: 600,
          maxWidth: 900,
          lineHeight: 1.5,
        }}
      >
        Data2Reality is currently undergoing testing. We would love your feedback!{' '}
        <Link
          href={FEEDBACK_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontWeight: 700 }}
          underline="always"
        >
          D2R Feedback Form
        </Link>
      </Typography>
      <IconButton
        onClick={() => setVisible(false)}
        size="small"
        sx={{ ml: 2, color: '#4a1711' }}
        aria-label="Dismiss feedback banner"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default FeedbackBanner;
